import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import moment, {Moment} from 'moment';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {getSlotsByOrder, isVenueOpen, sleep} from 'src/smoothr-web-app-core/utils/utils';
import {TimeUtils} from 'src/smoothr-web-app-core/utils/time-utils';
import {TranslateService} from '@ngx-translate/core';
import {PreorderType} from 'src/smoothr-web-app-core/enums/PreorderType';
import {FormControl} from '@angular/forms';

export enum SelectionTimeType {
	ASAP = 'asap',
	LATER = 'later',
}

@Component({
	selector: 'app-before-create-order-select-time-dialog',
	templateUrl: './before-create-order-select-time-dialog.component.html',
	styleUrls: ['./before-create-order-select-time-dialog.component.scss'],
})
export class BeforeCreateOrderSelectTimeDialogComponent implements OnInit {
	@Input() order: Order;
	@Input() venue: Venue;
	@Input() preorderType: PreorderType;
	@Input() button = true;

	public selectionTimeTypeEnum = SelectionTimeType;
	public selectedTimeType: SelectionTimeType = SelectionTimeType.LATER;
	public slots: Moment[] = [];
	public dates: Moment[] = [];
	public maxDates = 7;
	public slot: Moment;
	public TimeUtils = TimeUtils;
	public now: moment.Moment;
	public showDates: boolean = false;
	public showTime: boolean = false;
	public loading = false;
	public isOpeningTimeSheet: boolean = false;
	public selectedTime: Moment = null;
	public isAsap = false;
	public isAsapAvailable = false;
	public formControlTime = new FormControl();
	mapslot: Moment;

	constructor(private modalCtrl: ModalController, public translate: TranslateService) {}

	static async show(
		modalCtrl: ModalController,
		order: Order,
		venue: Venue,
		preorderType: PreorderType,
		isOpenRestaurant: boolean = false
	): Promise<{ asap: boolean; slot: Moment } | null> {
		const modal = await modalCtrl.create({
			component: BeforeCreateOrderSelectTimeDialogComponent,
			cssClass: ['auto-height', 'time-dialog'],
			componentProps: {
				venue,
				order,
				preorderType,
				isOpenRestaurant,
			},
			showBackdrop: true,
		});
		await modal.present();
		await sleep(100);
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	ngOnInit() {
		this.mapslot = moment(this.order.orderAt);
		this.checkIfAsapExist();
		console.log(this.order);
		if (this.order.orderAt) {
			this.patchValue(this.order.orderAt);
		} else {
			this.patchValue(this.slots[0]);
		}
		this.formControlTime.valueChanges.subscribe(v => {
			if (v) {
				this.order.orderAt = v;
				this.order.asap = false;
			} else {
				//adding orderAt if asap true
				const preparationTime =
					this.order.preorder.type === PreorderType.DELIVERY
						? this.venue.slot.readyOffsetDelivery
						: this.venue.slot.readyOffset || this.venue.offsets.preorder[this.preorderType].offset;
				this.order.orderAt = moment().add(preparationTime + 1, 'minutes');
				this.order.asap = true;
			}


			// this.selectedTime = v;
			// this.order.asap = false;
			// this.order.orderAt = v;
		});
	}
	public patchValue(value) {
		this.formControlTime.patchValue(value, { emitEvent: true });
		this.selectedTime = value;
	}
	public pushSlot(value) {
		return moment(value);
	}
	private checkIfAsapExist() {
		this.isAsapAvailable = TimeUtils.doesHoursMatchOffsets(moment(), this.preorderType === PreorderType.DELIVERY ? this.venue.deliveryHours : this.venue.openingHours, 0);
		console.log('wwwwww', this.isAsapAvailable);
		this.loadSlots();
	}

	async loadSlots() {
		try {
			this.loading = true;
			let slots = (await getSlotsByOrder(this.venue, this.order)).map(slot => moment(slot.time));

			if ((slots.length === 1 && !slots[0]) || slots.length < 1) {
				this.isOpeningTimeSheet = false;
				this.loading = false;
				this.modalCtrl.dismiss(null);
				return;
			}
			this.slots = slots;
			if (this.slots.length > 0 && !this.order.orderAt) {
				this.patchValue(this.slots[0]);
			}
			if (moment(this.order.orderAt).isBefore(moment())) {
				this.patchValue(this.slots[0]);
			}
			this.loading = false;
			console.log('slots', this.slots);
		} catch (e) {
			this.loading = false;
		}
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
	showTimeValue(time?: Moment) {
		if (time) {
			return moment(time).locale(this.translate.currentLang).format('HH:mm, dd');
		}
		if (this.isAsap) {
			return 'ASAP - Today';
		}
	}
	selectTime() {
		console.log('beofre crete ------', this.formControlTime.value);
		if (this.formControlTime.value) {
			this.modalCtrl.dismiss({ slot: this.selectedTime });
		}
		// if (this.isAsap) {
		// 	this.modalCtrl.dismiss({ asap: this.isAsap });
		// }
		// if (this.selectedTime) {
		// 	this.modalCtrl.dismiss({ slot: this.selectedTime });
		// }
	}

	protected readonly PreorderType = PreorderType;
}
